import React from 'react';
import PropTypes from 'prop-types';
import { theme } from 'gatsby-theme-fela';

import SingleColor from './SingleColor';

const ColorsExample = ({ styles }) => {
    const colorsMarkup = Object.keys(theme.colors)
        .filter(color => color !== 'form')
        .map(color => (
            <SingleColor key={color} colorName={color} colorValue={theme.colors[color]}>
                {color}
            </SingleColor>
        ));

    return <div className={styles.container}>{colorsMarkup}</div>;
};

ColorsExample.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
};

export default ColorsExample;
